import React, { useState, useEffect } from "react"
import { Helmet } from "react-helmet-async"

const TYPE_SITE = "site"
const TYPE_PRODUCT = "product"
const TYPE_SINGLE_REVIEW = "single-review"
const TYPE_STAR_BADGE = "star-badge"
const TYPE_LANDING_PAGE_REVIEW = "all-reviews"
const TYPE_EMPTY = 'empty'

const StampedEmbed = ({ 
  productEntries, 
  items, 
  className, 
  reviewsTitle, 
  reviewsDescription, 
  type: reviewsType = TYPE_SITE
}) => {
  const [type, setType] = useState(reviewsType)
  const [isLoaded, setIsLoaded] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState({});
  const toggleDropdown = () => setShowDropdown(!showDropdown);
  const [showReviews, setShowReviews] = useState(false);
  const [defaultTitle, setDefaultTitle] = useState('Select a product to review');

  const classList = `${className || ""} relative h-full md:p-0 flex justify-center`;
  const innerClassList = `relative w-full max-w-fit bg-white`;

  const descriptionItems = reviewsDescription?.map((review) => review.children.map((child) => child.text));

  useEffect(() => {
    if (Object.keys(selectedProduct).length > 0) {
      setType(TYPE_EMPTY)

      setTimeout(() => {
        setType(reviewsType)
        StampedFn.reloadUGC()
      }, 200)
    }
  }, [selectedProduct])

  const initWidget = () => {
    StampedFn.init({
      apiKey: "pubkey-9Zqs0W73P1lI2EbOx4yLlJw1x1C799",
      sId: 151706,
    })
    loadWidget()
  }

  const loadWidget = () => {
    const checkWidget = setInterval(() => {
      const isStampedReady =
        typeof window !== 'undefined' &&
        typeof window.isInitializedStamped !== 'undefined' &&
        window.isInitializedStamped === true
      const hasStamped = typeof StampedFn !== "undefined"

      if (hasStamped && isStampedReady) {
        StampedFn.loadWidget()
        // StampedFn.reloadUGC()
        clearInterval(checkWidget)
      }
    }, 250)
  }

	useEffect(() => {
		const scriptTag = document.querySelector("#stamped-js")

		if (!scriptTag && typeof StampedFn === "undefined") {
			setIsLoaded(true)
		}

		const onLoadHandler = e => {
			
		}

		const checkForJs = setInterval(() => {
			if (typeof StampedFn !== 'undefined') {
				clearInterval(checkForJs)
				initWidget()
			}
		}, 250)

    document.addEventListener("stamped:reviews:loaded", onLoadHandler)

		return () => {
			document.removeEventListener("stamped:reviews:loaded", onLoadHandler)
		}
	}, [selectedProduct])

	let productIds = [];
	let titles = [];
	let uris = [];

	if (type === TYPE_PRODUCT || type === TYPE_STAR_BADGE || type === TYPE_SINGLE_REVIEW) {
		productEntries?.forEach(productEntry => {
			const { uri, title, yotpoProductId } = productEntry;

			uris.push(uri);
			titles.push(title);
			productIds.push(yotpoProductId);
		});
	}
	
	const productIdProp = {};

	productIdProp['data-product-id' + (productIds.length > 1 ? 's' : '')] = productIds.join(',')

  const onItemSelect = (product) => {
    setSelectedProduct(product);
    setShowDropdown(false);
    setDefaultTitle(product.title);
    setShowReviews(true);
  };

  return (
    <>
      {type === TYPE_EMPTY && 
        <div className="container landing-page-wrapper">
          <div className="relative">
            <div className="flex flex-col items-center py-5 mb-8">
              <h1 className="mb-5">{reviewsTitle}</h1>
              {
                descriptionItems && descriptionItems.map((descriptionItem) => <p className="mb-3">{descriptionItem}</p>)
              }
            </div>
            <div className={classList}>
              <div className={innerClassList}>
                <div onClick={toggleDropdown} tabIndex={0} className={`relative flex xl:justify-center items-center cursor-pointer border border-gray rounded-lg`} >
                  <span className="w-full px-6 min-w-64">{defaultTitle}</span>
                  <span className="flex items-center p-2 border-l border-gray">
                    <svg width="20px" height="20px" viewBox="0 0 24.00 24.00" xmlns="http://www.w3.org/2000/svg" fill="#000000" stroke="#000000" strokeWidth="0.00024000000000000003">
                      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                      <g id="SVGRepo_iconCarrier"> 
                        <rect x="0" fill="none" width="24" height="24"></rect> 
                        <g> <path d="M20 9l-8 8-8-8 1.414-1.414L12 14.172l6.586-6.586"></path> </g>
                      </g>
                    </svg>
                  </span>
                </div>
                <ul className={`relative bg-white md:w-full md:left-0 h-auto rounded-xl transition-all duration-300 overflow-auto border-l border-r border-b border-gray ${showDropdown ? 'max-h-64 visible' : 'max-h-0 invisible'}`} aria-hidden={!showDropdown}>
                  {
                    items && items.map((item) => 
                      <li key={item.title} onClick={() => onItemSelect(item)} className="pt-2.5 pb-1.5 px-6 cursor-pointer flex items-center text-center" tabIndex={0}>
                        {item.title}
                      </li>
                    )
                  }
                </ul>
              </div>
            </div>
          </div>
          <div className="flex align-center w-full justify-center mt-8">
            <div role="status">
              <svg aria-hidden="true" class="w-8 h-8 text-gray animate-spin dark:text-gray-600 fill-green-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                  <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
              </svg>
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      }
      
      {type === TYPE_SITE && 
        <div id="stamped-reviews-widget" data-widget-type="full-page"></div>}

      {type === TYPE_SINGLE_REVIEW && 
        <div 
          id="stamped-reviews-widget"
          className="singleReview" 
          data-widget-type="single" 
          data-product-ids={productIds}
          style={{minHeight: "100px"}}
          ></div>}

      {type === TYPE_STAR_BADGE && 
        <span 
        className={`stamped-product-reviews-badge stamped-main-badge ${className || ""}`} 
        tab="-1"
        data-currency="USD"
        {...productIdProp}
        data-product-title={titles[0]}></span>
      }
      {type === TYPE_PRODUCT &&
        <div
          id="stamped-main-widget"
          data-widget-style="standard"
          {...productIdProp}
          data-currency="USD"
          data-name={titles.join(" & ")}
          data-url={`https://www.diggs.pet/${uris[0]}/`}
        ></div>
      }
      {type === TYPE_LANDING_PAGE_REVIEW &&
        <div className="container landing-page-wrapper">
          <div className="relative">
            <div className="flex flex-col items-center py-5 mb-8">
              <h1 className="mb-5">{reviewsTitle}</h1>
              {
                descriptionItems && descriptionItems.map((descriptionItem) => <p className="mb-3">{descriptionItem}</p>)
              }
            </div>
            <div className={classList}>
              <div className={innerClassList}>
                <div onClick={toggleDropdown} tabIndex={0} className={`relative flex xl:justify-center items-center cursor-pointer border border-gray rounded-lg`} >
                  <span className="w-full px-6 min-w-64">{defaultTitle}</span>
                  <span className="flex items-center p-2 border-l border-gray">
                    <svg width="20px" height="20px" viewBox="0 0 24.00 24.00" xmlns="http://www.w3.org/2000/svg" fill="#000000" stroke="#000000" strokeWidth="0.00024000000000000003">
                      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                      <g id="SVGRepo_iconCarrier"> 
                        <rect x="0" fill="none" width="24" height="24"></rect> 
                        <g> <path d="M20 9l-8 8-8-8 1.414-1.414L12 14.172l6.586-6.586"></path> </g>
                      </g>
                    </svg>
                  </span>
                </div>
                <ul className={`relative bg-white md:w-full md:left-0 h-auto rounded-xl transition-all duration-300 overflow-auto border-l border-r border-b border-gray ${showDropdown ? 'max-h-64 visible' : 'max-h-0 invisible'}`} aria-hidden={!showDropdown}>
                  {
                    items && items.map((item) => 
                      <li key={item.title} onClick={() => onItemSelect(item)} className="pt-2.5 pb-1.5 px-6 cursor-pointer flex items-center text-center" tabIndex={0}>
                        {item.title}
                      </li>
                    )
                  }
                </ul>
              </div>
            </div>
          </div>
          {
            showReviews && <div
              id="stamped-main-widget"
              data-widget-style="standard"
              {...productIdProp}
              data-product-id={selectedProduct.yotpoProductId}
              data-currency="USD"
              data-name={selectedProduct.title}
              data-url={`https://www.diggs.pet/${selectedProduct.uri}`}
            ></div>
          }
        </div>
        }
      <Helmet>
        <script
          id="stamped-script-widget"
          data-api-key="pubkey-9Zqs0W73P1lI2EbOx4yLlJw1x1C799"
          src="https://cdn1.stamped.io/files/widget.min.js"
          async
        ></script>
      </Helmet>
      {isLoaded && (
        <Helmet>
          <script
            id="stamped-script-widget"
            data-api-key="pubkey-9Zqs0W73P1lI2EbOx4yLlJw1x1C799"
            src="https://cdn1.stamped.io/files/widget.min.js"
            async
          ></script>
        </Helmet>
      )}
    </>
  )
}

export default StampedEmbed
